import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";

const enum fields {
    region = "region",
    portalId = "portalId",
    formId = "formId",
    target = "target",
    css = "css",
}

interface Props extends WidgetProps {
    fields: {
        [fields.region]: string;
        [fields.portalId]: number;
        [fields.formId]: string;
        [fields.target]: string;
        [fields.css]: string;
    };
}

const CENHubspotScriptForm: React.FunctionComponent<Props> = props => {
    const { productInfo, product } = React.useContext(ProductContext);
    const context = React.useContext(ProductContext);
    const inventoryInfo = productInfo?.inventory?.inventoryAvailabilityDtos;
    const availability = inventoryInfo && inventoryInfo[0]?.availability;
    const isCustomAvailabilityMsg = product?.properties?.isCustomAvailabilityMsg;
    const state = useAppSelector(
        (state) => state
    );

    const isPDP = getCurrentPage(state).type === "ProductDetailsPage";

    if (typeof window === "undefined") {
        return null;
    }

    function getDataLayer() {
        return (window as any).dataLayer;
    }
    const dataLayer = getDataLayer();

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if ((window as any).hbspt !== undefined) {
                (window as any).hbspt.forms.create({
                    region: props.fields.region,
                    portalId: props.fields.portalId,
                    formId: props.fields.formId,
                    target: "#hubspot",
                    css: props.fields.css,
                    onFormSubmit() {
                        if (isPDP && availability?.messageType === 2 && isCustomAvailabilityMsg === "false") {
                            if (dataLayer) {
                                dataLayer.push({
                                    event: "getadeliverydateFormSubmit",
                                    formID: "get_a_delivery_date_for_my_location"
                                });
                            }
                        }
                        if (isPDP && availability?.messageType === 2 && isCustomAvailabilityMsg === "true") {
                            if (dataLayer) {
                                dataLayer.push({
                                    event: "canIgetThisFasterFormSubmit",
                                    formID: "can_i_get_this_faster"
                                });
                            }
                        }
                    }
                });
            }
        });

        return () => {
            document.body.removeChild(script);
        };
    }, [props.fields.region, props.fields.portalId, props.fields.formId, props.fields.css]);
    return <div id="hubspot"></div>;
};

const widgetModule: WidgetModule = {
    component: CENHubspotScriptForm,
    definition: {
        group: "Basic",
        icon: "Rtf",
        displayName: "CEN PDP Hubspot Form",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.region,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.portalId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.formId,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.css,
                editorTemplate: "MultilineTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
